import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "@main/customers/actions/details/useDetailsAction";
import useExportAction from "@main/customers/actions/export/useExportAction";
import useResetPasswordMailAction from "@main/customers/actions/reset-password-mail/useResetPasswordMailAction";
import useActiveOrDisableAccountAction from "@main/customers/actions/active-or-disable-account/useActiveOrDisableAccountAction";
import { Truck, UserCircle } from "@phosphor-icons/react";
import useChangePasswordAction from "@main/customers/actions/change-password/useChangePasswordAction";

function CustomersPage(props: any) {
  const { filters, formDefaultValues, title } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues, title);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction, title);

  const { exportFunction, actionTemplate: exportActionTemplate } =
    useExportAction(filters);

  const {
    prepareResetPasswordFunction,
    actionTemplate: resetPasswordTemplate,
  } = useResetPasswordMailAction();

  const { detailsFunction } = useDetailsAction(0, title, formDefaultValues);

  const {
    prepareActiveOrDisableFunction,
    actionTemplate: activeOrDisableTemplate,
  } = useActiveOrDisableAccountAction(indexFunction);

  // Change password modal
  const {
    actionTemplate: changePasswordModal,
    prepareChangePasswordFunction,
  } = useChangePasswordAction();

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig(
        {
          initializeFunction, // We pass the function to initialize a new element (used in the create button)
          indexFunction, // We pass the function to index the table
          exportFunction,
          prepareRemoveFunction,
          prepareResetPasswordFunction,
          prepareActiveOrDisableFunction,
          detailsFunction,
          prepareChangePasswordFunction,
          /**newActionsTableConfig**/
        },
        title
      ),
    [
      initializeFunction,
      indexFunction,
      exportFunction,
      prepareRemoveFunction,
      prepareResetPasswordFunction,
      prepareActiveOrDisableFunction,
      detailsFunction,
      prepareChangePasswordFunction,
      title,
    ]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          {title === "retails" ? (
            <UserCircle size={24} />
          ) : title === "dealers" ? (
            <Truck size={24} />
          ) : null}
          {t(title)}
        </Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {removeActionTemplate}
        {exportActionTemplate}
        {resetPasswordTemplate}
        {activeOrDisableTemplate}
        {changePasswordModal}
      </Card.Body>
    </Card>
  );
}

export default CustomersPage;
